import { Trace } from '@/stores/type/plotlyChart'

async function getHtml(data: Trace[], layout: {}) {
  return `
  <head>
    <meta charset="utf-8" />
    <style>
      .box {
        height: 100%;
      }
    </style>
  </head>
  <body>
    <div id="plotly-output" class="box"></div>
    <script type="module">
      import "https://cdn.plot.ly/plotly-2.28.0.js"
      const myPlot = document.getElementById('plotly-output');
      Plotly.newPlot(
        'plotly-output', 
        ${JSON.stringify(data)}, 
        ${JSON.stringify(layout)}, 
        { 
          scrollZoom: true,
          modeBarButtonsToRemove: ['lasso', 'select']
        }
      );

      myPlot.on('plotly_legendclick', function(data){
        const clickedTraceName = data.data[data.curveNumber].name;
        const updatedVisibility = data.data.map((trace) => {
          if (trace.name === clickedTraceName) {
            return trace.visible === 'legendonly' ? true : 'legendonly'
          }
          return trace.visible
        })
        Plotly.restyle('plotly-output', { visible: updatedVisibility })
        return false
      });
    </script>
  </body>
`
}

export const exportChartToHTML = async (data: Trace[], layout: {}) => {
  const blob = new Blob([await getHtml(data, layout)], { type: 'text/html' })
  const url = URL.createObjectURL(blob)
  const downloader = document.createElement('a')
  downloader.href = url
  const now = new Date()
  downloader.download = 'chart_' + now.toLocaleString().replace(/[-/:,.\s]/g, '_') + '.html'
  downloader.click()
  URL.revokeObjectURL(url)
}
